export default __webpack_public_path__ + "static/media/Dividends-stock-photo.cb51f4c8.jpg";